import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef } from "react";

export const Animate = ({
  children,
  delay = 0.25,
  duration = 0.5,
  animation = "fade-down",
}) => {
  const ref = useRef(null);

  const isInView = useInView(ref, { once: true });

  const controls = useAnimation();

  const getAnimationStyle = () => {
    switch (animation) {
      case "fade-down":
        return {
          hidden: { opacity: 0, y: -75 },
          visible: { opacity: 1, y: 0 },
        };
      case "fade-up":
        return {
          hidden: { opacity: 0, y: 75 },
          visible: { opacity: 1, y: 0 },
        };
      default:
        return {
          hidden: { opacity: 0, y: -75 },
          visible: { opacity: 1, y: 0 },
        };
    }
  };

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);

  return (
    <motion.div
      ref={ref}
      variants={getAnimationStyle(animation)}
      initial="hidden"
      animate={controls}
      transition={{ duration: duration, delay: delay }}
    >
      {children}
    </motion.div>
  );
};
